// Enhance Sleek's drawer lifecycle without replacing its focus trap or close controls.
if (!customElements.get('fe-mobile-menu-events')) {
  customElements.define('fe-mobile-menu-events', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('menu-drawer');
      if (!this.drawer) return;
      this.abort = new AbortController();
      this.root = this.drawer.querySelector('.menu-drawer__menus');
      this.previous = null;
      // Root navigation should be usable immediately, without Sleek's long stagger.
      this.originalAnimation = this.drawer.animateMenuItems;
      this.drawer.animateMenuItems = () => {};
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.root, {attributes: true, subtree: true, attributeFilter: ['class', 'open']});
      this.drawer.addEventListener('drawer:handleAfterHide', () => {
        this.previous = null;
        this.root.querySelectorAll('[inert]').forEach(el => el.removeAttribute('inert'));
      }, {signal: this.abort.signal});
    }
    sync() {
      const active = this.root.querySelector('details.active');
      for (const item of this.root.children) item.inert = !!active && !item.contains(active);
      this.root.querySelectorAll('details > summary').forEach(el => { el.inert = !!active && el.parentElement === active; });
      if (active !== this.previous && this.drawer.hasAttribute('open')) {
        const previous = this.previous;
        this.previous = active;
        if (active) {
          this.savedScroll = this.root.scrollTop;
          this.root.scrollTop = 0;
          active.querySelector('.menu-drawer__item-back-link')?.focus({preventScroll:true});
        } else if (previous) {
          this.root.scrollTop = this.savedScroll || 0;
          previous.querySelector('summary')?.focus({preventScroll:true});
        }
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); if(this.drawer && this.originalAnimation) this.drawer.animateMenuItems = this.originalAnimation; }
  });
}
